import Vue from 'vue'
import App from './App'
import router from './router'

import 'normalize.css/normalize.css' // A modern alternative to CSS resets
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import '@/styles/index.scss' // global css
import 'font-awesome/css/font-awesome.min.css'
import filters from './components/filters'
import cal from './utils/calculation'
import fix from './utils/fixed'
import './utils/track'

Vue.prototype.$cal = cal
Vue.prototype.$fix = fix

Vue.use(ElementUI);
Vue.config.productionTip = false

// 引入mockjs
// require('./mock/homeAd.js')

//全局过滤器
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key]);
});

if(process.env.NODE_ENV!=="development"){
  console.log = function () {}
}
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js